'use client';

import clsx from 'clsx';
import { Heading2 } from '@/components/section/headings';
import AppLink from '@/components/i18n/AppLink';
import { Span, SURFACE_REVEAL, cn } from '@/components/ui';

export type HomeExploreLink = { href: string; label: string };
export type HomeSectionJump = { id: string; label: string };

export type HomeExploreSectionProps = {
  title: string;
  subtitle?: string;
  sectionsTitle: string;
  hubsTitle: string;
  sectionJumps: readonly HomeSectionJump[];
  hubLinks: readonly HomeExploreLink[];
  className?: string;
};

/**
 * Dual navigation band: in-page section anchors + main navbar hub destinations.
 */
const HomeExploreSection: React.FC<HomeExploreSectionProps> = ({
  title,
  subtitle,
  sectionsTitle,
  hubsTitle,
  sectionJumps,
  hubLinks,
  className,
}) => (
  <section
    id="explore"
    className={clsx('container-section page-section-band page-section-band--elevated', className)}
    aria-labelledby="home-explore-heading"
  >
    <div className="page-heading-wrap mb-8 md:mb-10">
      <div id="home-explore-heading">
      <Heading2
        title={title}
        subtitle={subtitle}
        titleClassName="text-prose"
        subtitleClassName="mt-3 text-prose-muted"
      />
    </div>
    </div>
    <div className="page-grid-explore">
      <div className={cn('page-glass-panel page-glass-panel--elevated', SURFACE_REVEAL)}>
        <h3 className="page-form-section-title">{sectionsTitle}</h3>
        <ul className="m-0 mt-4 flex list-none flex-wrap gap-2 p-0">
          {sectionJumps.map((s) => (
            <li key={s.id}>
              <a
                href={`#${s.id}`}
                className="page-anchor-chip"
              >
                {s.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className={cn('page-glass-panel page-glass-panel--elevated', SURFACE_REVEAL)}>
        <h3 className="page-form-section-title">{hubsTitle}</h3>
        <ul className="page-grid-hub-links mt-4">
          {hubLinks.map((hub) => (
            <li key={hub.href}>
              <AppLink
                href={hub.href}
                className="group page-hub-link"
              >
                <Span>{hub.label}</Span>
                <Span className="text-prose-muted group-hover:text-[var(--color-primary)]" aria-hidden>
                  →
                </Span>
              </AppLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default HomeExploreSection;
